import React from 'react';
import { ControlGroup } from './ControlGroup';

interface SmartInputProps {
  label: string;
  value: number;
  min: number;
  max: number;
  step?: number;
  onChange: (val: number) => void;
  darkMode: boolean;
}

export const SmartInput: React.FC<SmartInputProps> = ({ label, value, min, max, step = 1, onChange, darkMode }) => (
  <ControlGroup label={label}>
    <div className="flex gap-2 items-center">
      <input 
        type="range" 
        min={min} 
        max={max} 
        step={step} 
        value={value} 
        onChange={e => onChange(parseFloat(e.target.value))} 
        className="flex-1"
      />
      <input 
        type="text" 
        value={value} 
        onChange={e => {
          const val = parseFloat(e.target.value);
          if (!isNaN(val)) onChange(val);
        }}
        className={`w-14 px-1 py-0.5 text-[9px] font-mono font-bold text-center border rounded-md outline-none ${darkMode ? 'bg-neutral-800 border-neutral-700 text-white' : 'bg-white border-neutral-200 text-neutral-800'}`}
      />
    </div>
  </ControlGroup>
);